

import React from 'react';
import { TruckInsert } from '@/types';
import { AddEntityButton } from '@/shared/components/AddEntityButton';
import { FormField } from '@/shared/components/GenericFormDialog';

/**
 * トラック情報の追加ボタンのprops
 */
interface AddTruckButtonProps {
    onAdd: (data: TruckInsert) => Promise<boolean>;
    className?: string;
    disabled?: boolean;
}

/**
 * トラック情報の追加ボタン (Generic版)
 * 汎用AddEntityButtonを使用した実装
 */
export default function AddTruckButton({
    onAdd,
    className,
    disabled = false
}: AddTruckButtonProps) {

    // フォームフィールドの定義
    const fields: FormField[] = [
        {
            key: 'name',
            label: 'トラック名',
            type: 'text',
            required: true,
            placeholder: 'トラック名を入力してください',
        },
        {
            key: 'truck_type',
            label: 'トラック種別',
            type: 'text',
            required: false,
            placeholder: 'トラック種別を入力してください',
        },
        {
            key: 'daily_cost',
            label: '日単価 (円)',
            type: 'number',
            required: false,
            placeholder: '日単価を入力してください',
            min: 0,
        },
        {
            key: 'is_active',
            label: '有効状態',
            type: 'switch',
            required: false,
            placeholder: 'このトラックを現在使用可能にするか設定します。',
        },
    ];

    /**
     * フォーム送信処理
     * @param data フォームデータ
     */
    const handleSubmit = async (data: Partial<Record<string, unknown>>) => {
        await onAdd(data as unknown as TruckInsert);
    };

    return (
        <AddEntityButton
            entityName="トラック"
            fields={fields}
            onSubmit={handleSubmit}
            isLoading={disabled}
            buttonText="新規追加"
            className={className}
        />
    );
} 